export default function roundValue(num, decimalPlaces = 2){
    num = Math.round(num + "e" + decimalPlaces);
    return Number(num + "e" + -decimalPlaces);
}
